import {API_BASE_URL, API_UPLOAD_URL, PAGINATION_DEFAULT_LIMIT} from "./constants";
import {secureDownload, secureFetch} from "./authService";

export function getGeoActivity(query) {
    let url = API_BASE_URL + '/statistic/geoActivity?';

    if (query) {
        const {
            page = 0,
            size = PAGINATION_DEFAULT_LIMIT,
            operatorCompanyId,
            companyId,
            salesPointId,
            dateFrom,
            dateTo
        } = query;

        if (size) url = url + `&size=${size}`;
        if (page || page === 0) url = url + `&page=${page}`;
        if (operatorCompanyId) url = url + `&operatorCompanyId=${operatorCompanyId}`;
        if (companyId) url = url + `&companyId=${companyId}`;
        if (salesPointId) url = url + `&salesPointId=${salesPointId}`;
        if (dateFrom) url = url + `&dateFrom=${dateFrom}`;
        if (dateTo) url = url + `&dateTo=${dateTo}`;
    }

    return secureFetch(url, {
        method: 'GET',
    });
}

export function downloadGeoActivityCsv(query) {
    let url = API_UPLOAD_URL + '/statistic/geoActivity/csv?';

    if (query) {
        const {
            operatorCompanyId,
            companyId,
            salesPointId,
            dateFrom,
            dateTo
        } = query;

        if (operatorCompanyId) url = url + `&operatorCompanyId=${operatorCompanyId}`;
        if (companyId) url = url + `&companyId=${companyId}`;
        if (salesPointId) url = url + `&salesPointId=${salesPointId}`;
        if (dateFrom) url = url + `&dateFrom=${dateFrom}`;
        if (dateTo) url = url + `&dateTo=${dateTo}`;
    }

    return secureDownload(url, {
        method: 'GET'
    });
}


// WEBPACK FOOTER //
// ./src/helpers/geoActivityService.js